import React, {useContext,useState} from 'react';
import { useTranslate } from 'react-redux-multilingual'
import { IsAuthContext } from 'app/App';
import {CardPerso} from '@gull'
import FieldSectionCode from './FieldSectionCode'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/free-solid-svg-icons'
import axios from 'axios'
import swal from "sweetalert2";

const CodeSectionForm = (props) => {
    const t = useTranslate();
    const { authParam } = useContext(IsAuthContext);

    const handleSelectFieldSection = (e,sectionFieldSelect) => {
        props.setSectionFieldValue({...props.sectionFieldValue, [sectionFieldSelect]:e.target.value})
    };

    const addNewCorrespondenceField = (key) => {
        //On modifie l'array de "section1" par exemple
        //on ajoute une nouvelle ligne de champ de correspondance 
        let newData = props.sectionCorrespondenceValue[key] ? [...props.sectionCorrespondenceValue[key],{}] : [{}]

        //Ici on remplace "section1" par son nouvel array 
        let copySectionCorrespondenceValue = {...props.sectionCorrespondenceValue}
        copySectionCorrespondenceValue[key] = newData
        
        props.setSectionCorrespondenceValue(copySectionCorrespondenceValue)
    };

    let sectionConfigurationCode = []
    for (let i=0; i<props.nbrSection; i++){
        let numeroSection = i+1

        sectionConfigurationCode.push(
            <div key={'section'+numeroSection} className='col-12 col-md-4 form-group'>
                <CardPerso header={'Section '+numeroSection}>
                    <div className="row">
                        <div className={props.sectionFieldValue['section'+numeroSection]!='' ? "col-11" : "col-12"}>
                            <select disabled={props.validButton} value={props.sectionFieldValue['section'+numeroSection]} className='form-control' onChange={(e)=>handleSelectFieldSection(e,'section'+numeroSection)} >
                                <option value="">-- Select --</option>
                                {props.datas.map(dataField=>{
                                    if(props.isFor=='client'){
                                        return(
                                            <option key={dataField} value={dataField}>{
                                                dataField=='name' ? t('tableName')+' '+t('or').toLowerCase()+' '+t('company').toLowerCase() : 
                                                dataField=='firstname' ? t('tableFirstName') : 
                                                dataField=='type' ? t('clientType') : 
                                                dataField=='tel' ? t('tablePhone') : 
                                                dataField=='autretel' ? t('tableOtherPhone') : 
                                                dataField=='adresse' ? t('adressePhysique') : 
                                                dataField=='ville' ? t('labelVille') : 
                                                dataField=='pays' ? t('labelPays') : 
                                                dataField=='codepostal' ? t('labelCodePostal') : 
                                                dataField=='mode_reglement' ? t('labelDelaiReglement') : 
                                                dataField=='mail_relance' ? t('labelMailrelance') : 
                                                dataField=='newsletter' ? t('inscriptionNewsletter') : 
                                                dataField=='datedenaissance' ? t('dateDeNaissance') : 
                                                dataField=='tva_number' ? t('numeroTgc', {taxe:authParam.company.nomenclature_tgc}) : 
                                                dataField=='email' ? 'Email' : 
                                                dataField=='note' ? 'Note' : 
                                                t(dataField)
                                            }</option>
                                        )
                                    }else{
                                        return(
                                            <option key={dataField.name} value={dataField.name}>{
                                                dataField.name=='name' ? t('providerName') : 
                                                t(dataField.name) ? t(dataField.name) :
                                                dataField.name
                                            }</option>
                                        )
                                    }
                                })}
                            </select>
                        </div>
                        {props.sectionFieldValue['section'+numeroSection]!='' ?
                            <div className="col-1">
                                {props.validButton ?
                                    <FontAwesomeIcon icon={faPlus} className="text_muted"/>
                                :
                                    <FontAwesomeIcon icon={faPlus} className="pointer" onClick={()=>addNewCorrespondenceField('section'+numeroSection)}/>
                                }
                            </div>
                        :
                            false
                        }
                    </div>
                    {props.sectionFieldValue['section'+numeroSection]!='' ?
                        props.sectionCorrespondenceValue['section'+numeroSection] && props.sectionCorrespondenceValue['section'+numeroSection].map((correspondenceField,index) => {
                            return(
                                <FieldSectionCode
                                    key={index}
                                    valueCorrespondence={props.sectionCorrespondenceValue['section'+numeroSection]}
                                    sectionCorrespondenceValue={props.sectionCorrespondenceValue}
                                    setSectionCorrespondenceValue={props.setSectionCorrespondenceValue}
                                    correspondenceField={correspondenceField}
                                    numeroSection={numeroSection}
                                    index={index}
                                    isFor={props.isFor}
                                    sectionField={props.sectionFieldValue['section'+numeroSection]}
                                    allClientType={props.allClientType}
                                    validButton={props.validButton}
                                />
                            )
                        })
                    :
                        false
                    }
                </CardPerso>
            </div>
        )
    }

    return(
        <div className='row'>
            {sectionConfigurationCode}
        </div>
    )
}

export default CodeSectionForm;